import { jsx as _jsx } from "react/jsx-runtime";
import gemCategorySpatialIcon from '../../../assets/new_gems/Category/GemCategorySpatial.svg?inline';
export const GemCategorySpatial = (props) => {
    return _jsx("img", { ...props, src: gemCategorySpatialIcon, alt: 'GemCategorySpatialImage' });
};
